<template>
  <div class="guarantor-new">
    <Row :gutter="32">
      <i-col span="12">
        <Form ref="newForm" :model="guarantorModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="" v-if="$common.userType[$store.getters.userInfo.type.toString()] !== '保证人'">
            <Checkbox v-model="addGuarantorAndUser">同步创建用户</Checkbox>
          </FormItem>
          <FormItem label="姓名" prop="displayName"
            v-if="addGuarantorAndUser"
            :rules="addGuarantorAndUser?[{ required: true, message: '请填写名称', trigger: 'blur' }]:null">
            <Input v-model="guarantorModel.displayName" placeholder="输入姓名" />
          </FormItem>
          <FormItem label="登录用户名" prop="loginName"
            v-if="addGuarantorAndUser"
            :rules="addGuarantorAndUser?[{ required: true, message: '请填写用户名', trigger: 'blur' }]:null">
            <Input v-model="guarantorModel.loginName" placeholder="输入登录用户名" />
          </FormItem>
          <FormItem label="登录密码" prop="password"
            v-if="addGuarantorAndUser"
            :rules="addGuarantorAndUser?[{ required: true, message: '请填写密码', trigger: 'blur' }]:null">
            <Input v-model="guarantorModel.password" type="password" placeholder="输入登录密码" />
          </FormItem>
          <FormItem label="重复登录密码" prop="rePassword"
            v-if="addGuarantorAndUser"
            :rules="addGuarantorAndUser?[{ validator: validateRepassword, trigger: 'blur' }]:null">
            <Input v-model="guarantorModel.rePassword" type="password" placeholder="重复输入登录密码" />
          </FormItem>
          <FormItem label="手机号" prop="mobile" v-if="addGuarantorAndUser">
            <Input v-model="guarantorModel.mobile" placeholder="输入手机号" />
          </FormItem>
          <FormItem label="角色" prop="roleId"
            v-if="addGuarantorAndUser"
            :rules="addGuarantorAndUser?[{ type: 'number', required: true, message: '请选择角色', trigger: 'blur' }]:null">
            <Select v-model="guarantorModel.roleId" filterable>
              <Option v-for="(tp,idx) in roles" :key="idx" :disabled="tp.disabled" :value="parseInt(tp.tid)">{{tp.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="公司名称" prop="name">
            <Input v-model="guarantorModel.name" placeholder="输入公司名称" />
          </FormItem>
          <FormItem label="社会信用代码" prop="businessLicense">
            <Input v-model="guarantorModel.businessLicense" placeholder="输入社会信用代码" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="guarantorModel.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.guarantorType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="注册类型" prop="corpType">
            <Select v-model="guarantorModel.corpType" filterable>
              <Option value="有限责任公司">有限责任公司</Option>
              <Option value="股份有限公司">股份有限公司</Option>
              <Option value="有限合伙企业">有限合伙企业</Option>
              <Option value="外商独资公司">外商独资公司</Option>
              <Option value="个人独资企业">个人独资企业</Option>
              <Option value="国有独资公司">国有独资公司</Option>
              <Option value="其他">其他</Option>
            </Select>
          </FormItem>
          <FormItem label="营业期限" prop="businessTerm">
            <Date-picker type="date" v-if="!longTerm" :value="guarantorModel.businessTerm" @on-change="changeBusinessTerm" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>&nbsp;
            <Checkbox v-model="longTerm">长期</Checkbox>
          </FormItem>
          <FormItem label="注册地址" prop="address">
            <Input v-model="guarantorModel.address" placeholder="输入注册地址" />
          </FormItem>
          <Form-item label="经营范围" prop="scope">
            <Input v-model="guarantorModel.scope" placeholder="请输入经营范围" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
          </Form-item>
          <!-- <Form-item label="邮编" prop="postCode">
            <Input v-model="guarantorModel.postCode" placeholder="请输入邮编" style="width: 120px"></Input>
          </Form-item> -->
          <Form-item label="注册资本(万元)" prop="capital">
            <Input-number :min="0" :step="100" v-model="guarantorModel.capital"></Input-number>
            <Divider type="vertical" v-if="guarantorModel.capital" />
            <h3 style="display:inline-block" v-if="guarantorModel.capital"> {{`¥ ${guarantorModel.capital*10000}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="guarantorModel.capital" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guarantorModel.capital*10000)}}</h3>
          </Form-item>
          <Form-item label="成立日期" prop="estDate">
            <Date-picker type="date" :value="guarantorModel.estDate" @on-change="changeEstDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
          </Form-item>
          
          <!-- <Form-item label="公司网址" prop="homePage">
            <Input v-model="guarantorModel.homePage" placeholder="请输入公司网址">
              <span slot="prepend">http://</span>
            </Input>
          </Form-item>
          <Form-item label="电子邮箱" prop="email">
            <Input v-model="guarantorModel.email" placeholder="请输入电子邮箱"></Input>
          </Form-item> -->
          <Form-item label="保证业务总量" prop="totalGuaAmount"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1"
            :rules="[{ required: true, type: 'number', message: '请填写', trigger: 'blur' }]">
            <Input-number :min="0" :step="100" v-model="guarantorModel.totalGuaAmount"></Input-number>万元
          </Form-item>
          <Form-item label="偿付充足率信息" prop="solvency"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1"
            :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
            <Input type="textarea" v-model="guarantorModel.solvency" placeholder="偿付充足率信息"></Input>
          </Form-item>
          <Form-item :label="[2,3,10].indexOf(guarantorModel.type)>-1?'负责人':'联系人'" prop="contact">
            <Input v-model="guarantorModel.contact" :placeholder="[2,3,10].indexOf(guarantorModel.type)>-1?'负责人':'联系人姓名'"></Input>
          </Form-item>
          <Form-item label="联系电话" prop="contactTel"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
            <Input v-model="guarantorModel.contactTel" placeholder="联系电话"></Input>
          </Form-item>
          <Form-item label="公司电话" prop="contactTel" v-if="guarantorModel.type===1">
            <Input v-model="guarantorModel.contactTel" placeholder="公司电话"></Input>
          </Form-item>
          <!-- <Form-item label="联系人">
            <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="8">
                  <Form-item label="姓名" prop="contact">
                    <Input v-model="guarantorModel.contact" placeholder="联系人姓名"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="公司电话" prop="contactTel">
                    <Input v-model="guarantorModel.contactTel" placeholder="公司电话"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="传真" prop="fax">
                    <Input v-model="guarantorModel.fax" placeholder="联系人传真"></Input>
                  </Form-item>
                </Col>
              </Row>
              <div class="clearfix"></div>
            </div>
          </Form-item> -->
          <Form-item label="法定代表人" prop="legalPersonName">
            <Input v-model="guarantorModel.legalPersonName" placeholder="公司法人姓名"></Input>
            <!-- <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="8">
                  <Form-item label="姓名" prop="legalPersonName">
                    <Input v-model="guarantorModel.legalPersonName" placeholder="公司法人姓名"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职务" prop="legalPersonRole">
                    <Input v-model="guarantorModel.legalPersonRole" placeholder="法人职务"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职称" prop="legalPersonTitle">
                    <Input v-model="guarantorModel.legalPersonTitle" placeholder="法人职称"></Input>
                  </Form-item>
                </Col>
              </Row>
              <div class="clearfix"></div>
            </div> -->
          </Form-item>
          <Form-item label="法人联系电话" prop="legalPersonTel"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1"
            :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
            <Input v-model="guarantorModel.legalPersonTel" placeholder="法人联系电话"></Input>
          </Form-item>
          <Form-item label="管理人员" prop="supervisorContactPerson"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1"
            :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
            <Input v-model="guarantorModel.supervisorContactPerson" placeholder="管理人员"></Input>
          </Form-item>
          <Form-item label="管理人员电话" prop="supervisorContactTel"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1"
            :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
            <Input v-model="guarantorModel.supervisorContactTel" placeholder="管理人员电话"></Input>
          </Form-item>
          <Form-item label="管理机构" prop="supervisorName"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1"
            :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
            <Input v-model="guarantorModel.supervisorName" placeholder="管理机构名称"></Input>
          </Form-item>
          <Form-item label="管理机构电话" prop="supervisorTel"
            v-if="[2,3,10].indexOf(guarantorModel.type)>-1"
            :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
            <Input v-model="guarantorModel.supervisorTel" placeholder="管理机构电话"></Input>
          </Form-item>
          <Form-item label="总经理" prop="generalManagerName"
            v-if="guarantorModel.type===1"
            :rules="guarantorModel.type===1?[{ required: true, message: '请填写', trigger: 'blur' }]:null">
            <Input v-model="guarantorModel.generalManagerName" placeholder="总经理姓名"></Input>
            <!-- <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="8">
                  <Form-item label="姓名" prop="generalManagerName">
                    <Input v-model="guarantorModel.generalManagerName" placeholder="总经理姓名"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职务" prop="generalManagerRole">
                    <Input v-model="guarantorModel.generalManagerRole" placeholder="总经理职务"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职称" prop="generalManagerTitle">
                    <Input v-model="guarantorModel.generalManagerTitle" placeholder="总经理职称"></Input>
                  </Form-item>
                </Col>
              </Row>
              <div class="clearfix"></div>
            </div> -->
          </Form-item>
          <Form-item label="从业人员" prop="EmployeeTotal"
            v-if="guarantorModel.type===1">
            <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="6">
                  <Form-item label="专职从业人员" prop="qualifiedTotal"
                    :rules="guarantorModel.type===1?[{ required: true, type: 'number', message: '请填写', trigger: 'blur' }]:null">
                    <Input-number :min="0" v-model="guarantorModel.qualifiedTotal" placeholder="请输入专职从业人员"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="财务人员" prop="cpaTotal"
                    :rules="guarantorModel.type===1?[{ required: true, type: 'number', message: '请填写', trigger: 'blur' }]:null">
                    <Input-number :min="0" v-model="guarantorModel.cpaTotal" placeholder="请输入财务人员"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="法务工作人员" prop="solicitorTotal"
                    :rules="guarantorModel.type===1?[{ required: true, type: 'number', message: '请填写', trigger: 'blur' }]:null">
                    <Input-number :min="0" v-model="guarantorModel.solicitorTotal" placeholder="请输入法务工作人员"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <!-- <Row>
                <Col span="6">
                  <Form-item label="员工总数" prop="employeeTotal">
                    <Input-number :min="0" v-model="guarantorModel.employeeTotal" placeholder="请输入员工总数"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Form-item label="有职称" prop="titledTotal">
                    <Input-number :min="0" v-model="guarantorModel.titledTotal" placeholder="请输入有职称人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="中级职称" prop="titledMedTotal">
                    <Input-number :min="0" v-model="guarantorModel.titledMedTotal" placeholder="请输入中级职称人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="高级职称" prop="titledSeniorTotal">
                    <Input-number :min="0" v-model="guarantorModel.titledSeniorTotal" placeholder="请输入高级职称人数"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Form-item label="有执业资格" prop="qualifiedTotal">
                    <Input-number :min="0" v-model="guarantorModel.qualifiedTotal" placeholder="请输入有执业资格人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册监理工程师" prop="regSupervTotal">
                    <Input-number :min="0" v-model="guarantorModel.regSupervTotal" placeholder="请输入注册监理工程师人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册建造师" prop="regConstrTotal">
                    <Input-number :min="0" v-model="guarantorModel.regConstrTotal" placeholder="请输入注册建造师人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册造价师" prop="regCostTotal">
                    <Input-number :min="0" v-model="guarantorModel.regCostTotal" placeholder="请输入注册造价师人数"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Form-item label="项目经理" prop="prjManagerTotal">
                    <Input-number :min="0" v-model="guarantorModel.prjManagerTotal" placeholder="请输入项目经理人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册会计师" prop="cpaTotal">
                    <Input-number :min="0" v-model="guarantorModel.cpaTotal" placeholder="请输入注册会计师人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="律师" prop="solicitorTotal">
                    <Input-number :min="0" v-model="guarantorModel.solicitorTotal" placeholder="请输入律师人数"></Input-number>
                  </Form-item>
                </Col>
              </Row> -->
              <div class="clearfix"></div>
            </div>
          </Form-item>
          <!-- <Form-item label="企业简介" prop="description">
            <Input v-model="guarantorModel.introduction" placeholder="请输入企业简介" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
          </Form-item>
          <Form-item label="担保经营范围" prop="guarRange">
            <Input v-model="guarantorModel.guarRange" placeholder="请输入担保经营范围" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
          </Form-item> -->
          <!-- <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem> -->
        </Form>
      </i-col>
      <i-col span="12">
        <Form ref="attachmentForm" :model="guarantorModel"
          v-if="getConfig('GUARANTO_RREGISTER_ATTACHMENT_REQUIREMENTS')
            ||getConfig('GUARANTOR_BANK_REGISTER_ATTACHMENT_REQUIREMENTS')"
          label-position="left"
          :label-width="200">
          <div class="font-grey" v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')
            ||getConfig('GUARANTOR_BANK_REGISTER_ATTACHMENT_SAMPLE_URL')">
            <span v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')">{{getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')}}</span>
            <a :href="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')">点击下载</a>
            <div class="padding-top-20"></div>
          </div>
          <FormItem :label="att.name" :prop="`attachments[${idx}].url`" v-for="(att,idx) in guarantorModel.attachments" :key="idx"
            :rules="att.required?[{required:true,validator:arrayValidator,trigger:'change'}]:[]">
            <Upload
              ref="attachmentUploader"
              :data="OSSParam"
              :before-upload="handleBeforeUpload"
              :multiple="true"
              :max-size="att.fileSizeLimit"
              :on-success="handleUploadSuccess"
              :format="getFormats(att.formats)"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleExceededSize"
              :on-remove="removeItem"
              :on-preview="previewUploaded"
              :show-upload-list="false"
              :action="uploadParams.host">
              <Poptip trigger="hover" placement="bottom">
                <Button @click="getOSSParams(idx)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
                <div slot="content">
                  <span class="small font-grey">格式要求:{{att.formats}}<br>文件大小限制: {{att.fileSizeLimit}}kb<br>文件数量上限: {{att.fileCountLimit}}</span>
                </div>
              </Poptip>
            </Upload>
            <div class="attachments">
              <div class="attachment-thumb"
                @click="previewImgUrl=item;showPreview=true"
                :key="index"
                v-for="(item,index) in att.url">
                <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                <div class="attachment-thumb-cover">
                  <Icon type="ios-eye-outline" @click.stop="previewImgUrl=item;showPreview=true"></Icon>
                  <Icon type="ios-trash-outline" @click.stop="removeItem(item, idx)"></Icon>
                </div>
                <!-- <template v-if="item.status === 'finished'">
                  <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                  <div class="attachment-thumb-cover">
                    <Icon type="ios-eye-outline" @click="previewImgUrl=item.url;showPreview=true"></Icon>
                    <Icon type="ios-eye-outline" @click="removeItem(item, idx)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template> -->
              </div>
            </div>
          </FormItem>
          <div class="font-grey" v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')
            ||getConfig('GUARANTOR_BANK_REGISTER_ATTACHMENT_SAMPLE_URL')">
            <span v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')">{{getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')}}</span>
            <a :href="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')">点击下载</a>
            <div class="padding-top-20"></div>
          </div>
        </Form>
      </i-col>
    </Row>
    <Row :gutter="32">
      <i-col span="12">
        <Button type="primary" size="large" long @click="submit">提交</Button>
      </i-col>
      <i-col span="12" v-if="$common.userType[$store.getters.userInfo.type.toString()] === '保证人'">
        <Button type="warning" size="large" long @click="submitDraft">存草稿</Button>
      </i-col>
    </Row>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new',
  props: {
  },
  data () {
    return {
      loading: false,
      addGuarantorAndUser: true,
      guarantorModel: {
        loginName: null,
        password: null,
        rePassword: null,
        passwordMd5: null,
        mobile: null,
        displayName: null,
        roleId: null,
        name: null,
        businessLicense: null,
        legalPersonName: null,
        corpType: null,
        businessTerm: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        legalPersonTel: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        supervisorName: null,
        supervisorTel: null,
        supervisorContactPerson: null,
        supervisorContactTel: null,
        solvency: null,
        totalGuaAmount: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
        attachments: null
      },
      roles: [],
      longTerm: false,
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        ],
        type: [
          { required: true, type: 'number', message: '请填写', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        scope: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        capital: [
          { required: true, type: 'number', message: '请填写', trigger: 'blur' }
        ],
        corpType: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        businessTerm: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        estDate: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请填写业务联系人', trigger: 'blur' }
        ],
        contactTel: [
          { required: true, message: '请填写业务联系电话', trigger: 'blur' }
        ],
        legalPersonName: [
          { required: true, message: '请填写', trigger: 'blur' }
        ]
      },
      cities: [],
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      curOSSParamIndex: 0,
      previewImgUrl: null,
      showPreview: false
    }
  },
  watch: {
    longTerm: function (newVal) {
      if (newVal) {
        this.guarantorModel.businessTerm = '长期'
      } else {
        this.guarantorModel.businessTerm = null
      }
    },
    'guarantorModel.type': function () {
      this.initAttachment()
    }
  },
  mounted () {
    if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '保证人') {
      this.addGuarantorAndUser = false
    }
    this.initCitySelect()
    this.initAttachment()
    this.initRoles()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async initRoles () {
      let res = await this.$Api.Role.listRoles({
        name: null,
        type: 3,
        isReserved: null
      }, 1, -1).catch(err => {
        console.log(err)
        this.$Message.error(err.message)
      })
      this.roles = res.data
    },
    validateRepassword (rule, value, callback) {
      if (this.guarantorModel.password && value !== this.guarantorModel.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    },
    initAttachment () {
      let attaches = [2,3,10].indexOf(this.guarantorModel.type)>-1 ?
        this.getConfig('GUARANTOR_BANK_REGISTER_ATTACHMENT_REQUIREMENTS')
        : this.getConfig('GUARANTOR_REGISTER_ATTACHMENT_REQUIREMENTS')
      if (attaches && attaches instanceof Array && attaches.length) {
        this.guarantorModel.attachments = attaches.map(a => {
          a.filePath = null
          a.ossKeys = []
          a.url = []
          return a
        })
      }
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    changeBusinessTerm (date) {
      this.guarantorModel.businessTerm = this.$moment(date).format('YYYY-MM-DD')
    },
    changeEstDate (date) {
      this.guarantorModel.estDate = this.$moment(date).format('YYYY-MM-DD')
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getFormats (fmtStr) {
      let arr = fmtStr.split(',')
      let result = arr.map((a) => {
        return a.trim()
      })
      return result
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.guarantorModel.regCity = val[val.length - 1]
      } else {
        this.guarantorModel.regCity = val
      }
    },
    getOSSParams (index) {
      this.$Api.Guarantor.getUploadParams('profile').then((res) => {
        console.log(res)
        this.uploadParams = {
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
    },
    async handleUploadSuccess (response, file, fileList) {
      let index = this.OSSParams.findIndex(o => o && o.name === file.name)
      let attach = this.guarantorModel.attachments[index]
      if (fileList.length > attach.fileCountLimit) {
        fileList.splice(0, 1)
        this.guarantorModel.attachments[index].ossKeys.splice(0, 1)
      }
      if (!this.guarantorModel.attachments[index].ossKeys) {
        this.guarantorModel.attachments[index].ossKeys = []
      }
      if (!this.guarantorModel.attachments[index].url) {
        this.guarantorModel.attachments[index].url = []
      }
      let ossParam = this.OSSParams[index]
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(url => {
          url.status = 'finished'
          this.guarantorModel.attachments[index].url.push(url)
        })
        this.guarantorModel.attachments[index].ossKeys.push(filename)
        this.guarantorModel.attachments[index].filePath = this.guarantorModel.attachments[index].ossKeys.join(',')
      })
    },
    removeItem (item, attachIdx) {
      let attach = this.guarantorModel.attachments[attachIdx]
      let idx = attach.url.findIndex(o => o.name === item.name)
      attach.url.splice(idx, 1)
      let keys = attach.filePath.split(',')
      keys.splice(idx, 1)
      keys = keys.join(',')
      console.log(keys)
      this.guarantorModel.attachments[attachIdx].ossKeys = keys
      this.guarantorModel.attachments[attachIdx].filePath = keys
    },
    // removeItem (item, fileList) {
    //   let key = item.name.indexOf('oss:') === 0 ? item.name.substr(4) : item.name
    //   let index = this.OSSParams.findIndex(o => o.key === key)
    //   this.guarantorModel.attachments[index].ossKeys = fileList.map((a) => {
    //     return a.name
    //   })
    //   this.guarantorModel.attachments[index].filePath = this.guarantorModel.attachments[index].ossKeys.join(',')
    // },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    handleExceededSize () {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '上传文件大小超出限制范围。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    async submit () {
      let formValid = false
      if (this.guarantorModel.businessTerm) {
        this.guarantorModel.businessTerm = require('moment')(this.guarantorModel.businessTerm).format('YYYY-MM-DD')
      }
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.$refs.attachmentForm.validate(async (valid2) => {
            formValid = valid2
          })
        }
      })
      if (formValid) {
        this.loading = true
        this.$Spin.show()
        let model = JSON.parse(JSON.stringify(this.guarantorModel))
        let payload
        if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '保证人') {
          if (!model.estDate) {
            model.estDate = null
          }
          if (!model.attachments) {
            model.attachments = []
          }
          model.attachments.forEach((att) => {
            if (att.url instanceof Array) {
              att.url = att.url.map((u) => {
                return u.name.replace('oss:', '')
              }).join(',')
            }
          })
          payload = await Api.Guarantor.submitNewGuarantor(model)
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        } else {
          if (!model.attachments) {
            model.attachments = []
          }
          model.attachments.forEach((att) => {
            if (att.url instanceof Array) {
              att.url = att.url.map((u) => {
                return u.name.replace('oss:', '')
              }).join(',')
            }
          })
          if (this.addGuarantorAndUser) {
            model.passwordMd5 = this.$md5(model.password)
            payload = await Api.Guarantor.addGuarantorAndUser(model)
              .catch(err => {
                console.log('err', err)
                this.$Message.error('提交失败!' + err.message)
                this.loading = false
                this.$Spin.hide()
              })
          } else {
            payload = await Api.Guarantor.addGuarantor(model)
              .catch(err => {
                console.log('err', err)
                this.$Message.error('提交失败!' + err.message)
                this.loading = false
                this.$Spin.hide()
              })
          }
        }
        if (payload) {
          console.log('suc', payload)
          this.$Message.success('新增成功!')
          this.guarantorModel = {
            loginName: null,
            password: null,
            rePassword: null,
            passwordMd5: null,
            mobile: null,
            displayName: null,
            roleId: null,
            name: null,
            businessLicense: null,
            legalPersonName: null,
            contact: null,
            contactTel: null,
            regCity: null,
            address: null,
            email: null,
            postCode: null,
            capital: null,
            estDate: null,
            scope: null,
            homePage: null,
            fax: null,
            legalPersonID: null,
            legalPersonIDImgs: [],
            legalPersonRole: null,
            legalPersonTitle: null,
            generalManagerName: null,
            generalManagerRole: null,
            generalManagerTitle: null,
            employeeTotal: 0,
            titledTotal: 0,
            titledMedTotal: 0,
            titledSeniorTotal: 0,
            qualifiedTotal: 0,
            regSupervTotal: 0,
            regConstrTotal: 0,
            regCostTotal: 0,
            prjManagerTotal: 0,
            cpaTotal: 0,
            solicitorTotal: 0,
            introduction: null,
            guarRange: null,
            orgChartPath: '',
            attachments: null
          }
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        }
      }
    },
    async submitDraft () {
      this.loading = true
      this.$Spin.show()
      let payload
      if (this.guarantorModel.businessTerm) {
        this.guarantorModel.businessTerm = require('moment')(this.guarantorModel.businessTerm).format('YYYY-MM-DD')
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '保证人') {
        let model = JSON.parse(JSON.stringify(this.guarantorModel))
        if (!model.estDate) {
          model.estDate = null
        }
        model.attachments.forEach((att) => {
          if (att.url instanceof Array) {
            att.url = att.url.map((u) => {
              return u.name.replace('oss:', '')
            }).join(',')
          }
        })
        payload = await Api.Guarantor.submitDraft(model)
          .catch(err => {
            console.log('err', err)
            this.$Message.error('提交失败!' + err.message)
            this.loading = false
            this.$Spin.hide()
          })
      }
      if (payload) {
        console.log('suc', payload)
        this.$Message.success('保存成功!')
        this.loading = false
        this.$Spin.hide()
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  cursor: pointer;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>
